import axios from "axios";
import authHeader from "./auth-header";
import IServiceOrderEvaluation from "../types/service-order-evaluation.type";
import IServiceOrderChangeStatus from "../types/service-order-change-status.type";
import IServiceOrderEvaluationChangeStatus from "../types/service-order-evaluation-change-status.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/service-order-evaluation`;

export const getById = (id: any) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const update = (id: number, serviceOrderEvaluation: IServiceOrderEvaluation) => {
  return axios.put(API_URL + "/" + id, serviceOrderEvaluation, { headers: authHeader() });
};

export const getServiceOrdersEvaluationsByServiceOrderId = (serviceOrderId: number) => {
  return axios.get(API_URL + "/by-service-oder/" + serviceOrderId, { params: {}, headers: authHeader() });
};

export const getMyServiceOrdersEvaluations = (params: {}) => {
  return axios.get(API_URL + "/my-evaluations", { params: params, headers: authHeader() });
};

export const completeEvaluation = (id: any, serviceOrderEvaluationChangeStatus: IServiceOrderEvaluationChangeStatus) => {
  return axios.put(API_URL + "/" + id + "/complete", serviceOrderEvaluationChangeStatus, { headers: authHeader() });
};
